import React from 'react';
import { browserHistory } from 'react-router';
import PropTypes from 'prop-types';
import Table from '../../../core/form/Table';
import Button from '../../../core/form/Button';
import { Roles } from '../../../core/util';

const GrammarList = (props) => (
  <Table
    fetching={props.fetching}
    columns={[
      {
        label: 'Name',
        path: 'name',
      },
      {
        label: 'Description',
        path: 'description',
        render: (value) => value.find((i) => i.locale === 'en')?.value,
      },
      ...([Roles.ADMIN, Roles.CONTENT_ADMIN].includes(localStorage.role)
        ? [
            {
              label: 'Distributor',
              path: 'distributor.name',
            },
          ]
        : []),
      {
        label: 'Actions',
        path: 'action',
        width: '80px',
        render: (cell, row) => <Button icon="edit" onClick={() => browserHistory.push(`/grammars/${row.id}`)} />,
      },
    ]}
    rows={props.grammars}
    pagination={props.pagination}
    onChange={props.onChange}
  />
);

GrammarList.propTypes = {
  grammars: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
  pagination: PropTypes.shape({
    current: PropTypes.number,
    total: PropTypes.number,
    pageSize: PropTypes.number,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  fetching: PropTypes.bool.isRequired,
};

export default GrammarList;
